import { c6BankService } from "@/app/services/c6BankService";
import masks from "@/app/utils/masks";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const DEFAULT_ERROR = "Não foi possível verificar as ofertas no momento";

export default function useC6BankSimulation() {
  const { cpf } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [installmentsList, setInstallmentsList] = useState<number[]>([]);
  const [selectedInstallment, setSelectedInstallment] = useState(0);
  const [installmentInput, setInstallmentInput] = useState("");

  const currentInstallmentRef = useRef(0);

  const fetchOffers = async () => {
    if (!cpf) return;

    try {
      setLoading(true);
      setError(null);

      const response = await c6BankService.getOffers({ cpf });

      if (!response.offers) {
        setError(response.message || DEFAULT_ERROR);
        return;
      }

      const { offers } = response;
      const list = offers.installmentsList ?? [];
      const value =
        Number(
          String(offers.installmentValue).replace(/\./g, "").replace(",", "."),
        ) || 0;

      setInstallmentsList(list);
      currentInstallmentRef.current = value;
      setInstallmentInput(
        value ? masks.currency(String(offers.installmentValue).replace(/\D/g, "")) : "",
      );
      setSelectedInstallment(list[list.length - 1] ?? 0);
    } catch (err: any) {
      setError(err?.message || DEFAULT_ERROR);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, [cpf]);

  const handleSelectInstallment = (prazo: number) => {
    setSelectedInstallment(prazo);
  };

  const handleContinue = () => {
    if (!cpf || !currentInstallmentRef.current || !selectedInstallment) return;

    navigate(`/transacoes/${cpf}/c6/offers`, {
      state: {
        valorParcela: currentInstallmentRef.current,
        prazo: selectedInstallment,
      },
    });
  };

  return {
    loading,
    error,
    installmentsList,
    selectedInstallment,
    installmentInput,
    setInstallmentInput,
    currentInstallmentRef,
    handleSelectInstallment,
    handleContinue,
  };
}
